// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2DSIE","title":"Images90_title__3ezLG","images":"Images90_images__3hrrW"};